import type { SuperAdminReminder } from '../../services/SuperAdminService';

/**
 * Süperadmin hatırlatmalarının derin bağlantısı.
 *
 * Bildirimden tıklanan kalem, kendi sekmesi açılıp arama kutusuna ayırt edici
 * bilgisi yazılarak gösterilir (yazarkasada seri no, sözleşmede şirket adı).
 *
 * Parametre adları burada tek kaynaktan tutulur; bağlantıyı üreten bildirimler
 * ile onu okuyan SuperAdmin ekranı aynı sabitleri kullanır.
 */
export const REMINDER_TAB_QUERY = 'tab';
export const REMINDER_SEARCH_QUERY = 'q';

export const buildReminderHref = (reminder: Pick<SuperAdminReminder, 'targetTab' | 'searchText' | 'title' | 'kind' | 'companyId' | 'key' | 'expiryDate'>): string => {
  if (reminder.targetTab === 'billing') {
    const params = new URLSearchParams({
      prefill: reminder.kind,
      companyId: reminder.companyId,
      key: reminder.key,
      title: reminder.title || '',
    });
    if (reminder.expiryDate) params.set('expiry', reminder.expiryDate);
    return `/superadmin/billing?${params.toString()}`;
  }
  const search = (reminder.searchText || reminder.title || '').trim();
  const params = new URLSearchParams({ [REMINDER_TAB_QUERY]: reminder.targetTab });
  if (search) params.set(REMINDER_SEARCH_QUERY, search);
  return `/superadmin?${params.toString()}`;
};
